var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "#FFB201",
    stroke: "#FFB201",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1875_6514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.8333C22.188 10.8333 24.2865 11.7024 25.8336 13.2496C27.3808 14.7968 28.25 16.8952 28.25 19.0833C28.25 21.9011 26.7137 24.2074 25.0948 25.862C24.2859 26.6796 23.4034 27.4209 22.4585 28.0767L22.068 28.3425L21.8847 28.4644L21.5391 28.6844L21.2311 28.8723L20.8498 29.0942C20.5908 29.2416 20.298 29.3191 20 29.3191C19.702 29.3191 19.4092 29.2416 19.1502 29.0942L18.7689 28.8723L18.2923 28.579L18.1163 28.4644L17.7404 28.2142C16.7211 27.5242 15.7715 26.7364 14.9052 25.862C13.2863 24.2056 11.75 21.9011 11.75 19.0833C11.75 16.8952 12.6192 14.7968 14.1664 13.2496C15.7135 11.7024 17.812 10.8333 20 10.8333ZM20 16.3333C19.6389 16.3333 19.2813 16.4044 18.9476 16.5426C18.614 16.6808 18.3108 16.8833 18.0555 17.1387C17.8001 17.3941 17.5975 17.6972 17.4593 18.0309C17.3211 18.3645 17.25 18.7221 17.25 19.0833C17.25 19.4444 17.3211 19.802 17.4593 20.1356C17.5975 20.4693 17.8001 20.7724 18.0555 21.0278C18.3108 21.2832 18.614 21.4857 18.9476 21.6239C19.2813 21.7621 19.6389 21.8333 20 21.8333C20.7293 21.8333 21.4288 21.5435 21.9445 21.0278C22.4603 20.5121 22.75 19.8126 22.75 19.0833C22.75 18.3539 22.4603 17.6544 21.9445 17.1387C21.4288 16.623 20.7293 16.3333 20 16.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1875_6514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.a59bb4926fd39b45b511fa71d67ceaf0.svg";
export { ForwardRef as ReactComponent };